import type { ApiV2PageStrateImage } from '@dce-front/hodor-types/api/v2/page/dtos/strates/image';
import { Binder, type BinderProps } from '@dce-front/one-navigation';
import type { ResizeMode } from '@dce-front/onewebapp-utils';
import { ShowcaseImage as SharedShowcaseImage } from '@dce-front/sharedcomponent';
import Linker from '../../../../components/Linker/Linker';
import { useOnFocusable } from '../../../../helpers/hooks/useOnFocusable';
import type { FocusManager } from '../../../../helpers/oneNavigation/FocusManager';
import styles from '../Showcase.css';

type ShowcaseImageProps = {
  focusManager?: FocusManager;
  strate: ApiV2PageStrateImage;
  resizeMode?: ResizeMode;
} & Pick<BinderProps, 'binderId' | 'middleware'>;

function ShowcaseImage({
  strate,
  binderId,
  focusManager,
  middleware,
  resizeMode,
}: ShowcaseImageProps) {
  const [firstButton] = strate.buttons || [];
  const [firstContent] = strate.contents || [];
  useOnFocusable(focusManager);

  return (
    <Binder binderId={binderId} middleware={middleware}>
      <SharedShowcaseImage
        button={firstButton}
        content={firstContent}
        description={strate.description}
        focusStyle={styles.showcase__focusStyle}
        isTvDevice={$_BUILD_RENDERMODE_CSR}
        resizeMode={resizeMode}
        Linker={Linker}
        title={strate.title}
      />
    </Binder>
  );
}

export default ShowcaseImage;
